<template>
  <div class="chart-box">
    <canvas ref="chartCanvas"></canvas>
  </div>
</template>

<script setup>
import { ref, onMounted, watch } from 'vue'
import Chart from 'chart.js/auto'

const props = defineProps({
  chartData: {
    type: Object,
    required: true
  },
  chartOptions: {
    type: Object,
    required: true
  },
  height: {
    type: String,
    default: '300px'
  },
  type: {
    type: String,
    default: 'line'
  }
})

const chartCanvas = ref(null)
let chart = null

const initChart = () => {
  if (chart) {
    chart.destroy()
  }

  if (chartCanvas.value) {
    const ctx = chartCanvas.value.getContext('2d')
    chart = new Chart(ctx, {
      type: props.type,
      data: props.chartData,
      options: {
        ...props.chartOptions,
        responsive: true,
        maintainAspectRatio: false
      }
    })
  }
}

// 监听数据变化
watch(() => props.chartData, (newData) => {
  if (chart) {
    chart.data = newData
    chart.update()
  } else {
    initChart()
  }
}, { deep: true })

// 监听配置变化
watch(() => props.chartOptions, (newOptions) => {
  if (chart) {
    chart.options = {
      ...newOptions,
      responsive: true,
      maintainAspectRatio: false
    }
    chart.update()
  } else {
    initChart()
  }
}, { deep: true })

// 监听类型变化
watch(() => props.type, () => {
  if (chart) {
    chart.destroy()
    chart = null
  }
  initChart()
})

onMounted(() => {
  initChart()
})
</script>

<style scoped>
.chart-box {
  width: 100%;
  height: v-bind(height);
  position: relative;
}
</style>
  